import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Box,
  makeStyles,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  Popper,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import BodyText from "../components/reusableComponents/BodyText";
import { Form, Formik } from "formik";
import { useHistory } from "react-router-dom";
import { setselectedFDSector } from "../reducers/UiReducer";
import DesktopDateFd from "../components/reusableComponents/DestopDateFd";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      "& div": {
        "& div": {
          display: "none",
        },
      },
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
    "& input": {
      fontSize: 14,
      fontWeight: 600,
      padding: "0px 4px 4px 0px",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },

    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-184whfw-MuiAutocomplete-root .MuiAutocomplete-inputRoot":
      {
        paddingRight: 0,
      },
    "& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-xzqck1-MuiAutocomplete-root .MuiAutocomplete-inputRoot":
      {
        paddingRight: 0,
      },
  },
  radio: {
    "& .MuiRadio-root": {
      color: "grey",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#f50057",
    },
    "& .MuiTypography-body1": {
      color: "black",
      fontSize: "14px",
    },
  },
  radio2: {
    "& .MuiRadio-root": {
      color: "black",
    },
    "& .MuiRadio-colorSecondary.Mui-checked": {
      color: "#f50057",
    },
    "& .MuiTypography-body1": {
      color: "black",
      fontSize: "14px",
    },
  },
  popper: {
    "& .MuiAutocomplete-listbox": {
      "& :hover": {
        color: "rgb(0, 87, 94)",
      },
    },
  },
}));
const FDSearchEngine = () => {
  const classes = useStyles();
  const { fdsector } = useSelector((state) => state.promo);
  const { agentlogin } = useSelector((state) => state.user);
  const [filterData, setFilterData] = useState("");
  const handleRadio = (event) => {
    setValue(event.target.value);
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const [adult, setAdult] = useState(1);
  const [child, setChild] = useState(0);
  const [infant, setInfant] = useState(0);
  const [value, setValue] = useState("Economy");
  const {
    origin,
    selectedFDSector,
    fddate,
  } = useSelector((state) => state.ui);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const handleSubmit = (data) => {
    let formData = {
      Origin: selectedFDSector.origin,
      Destination: selectedFDSector.destination,
      DepartureDate: fddate,
      AdultCount: adult,
      ChildCount: child,
      InfantCount: infant,
      AirlineCode: "",
      agent_id: agentlogin
        ? agentlogin.status === 200
          ? agentlogin?.result.result.id
          : 0
        : 0,
    };

    history.push({
      pathname: `/fdoneway/${selectedFDSector.origin}/${selectedFDSector.destination}`,
      state: {
        body: formData,
        OriginO: origin,
      },
    });
  };

  const handleSearchOrigin = (event) => {
    let value = event ? event.target.value.toLowerCase() : "del";
    let results = [];
    results =
      fdsector &&
      fdsector?.result &&
      fdsector?.result?.data?.filter((item) => {
        return (
          item.sector.toLowerCase().includes(value.toLowerCase()) ||
          item.origin.toLowerCase().includes(value.toLowerCase()) ||
          item.destination.toLowerCase().includes(value.toLowerCase())
        );
      });
    console.log("searchresult", results);
    if (event) {
    } else {
      dispatch(setselectedFDSector(results ? results[0] : null));
    }
    if (results?.length < 80) {
      setFilterData(results);
    }
  };

  useEffect(() => {
    handleSearchOrigin();
  }, []);
  const PopperMy = function (props) {
    return (
      <Popper
        {...props}
        style={styles.popper}
        className={classes.popper}
        placement="bottom-start"
      />
    );
  };

  const styles = (theme) => ({
    popper: {
      width: "fit-content",
    },
  });
  return (
    <>
      <Formik
        initialValues={{
          Origin: "",
          Destination: "",
        }}
        validate={(values) => {
          const errors = {};
        }}
        onSubmit={handleSubmit}
      >
        {({ submitForm, isSubmitting, setFieldValue, values }) => (
          <>
            <Form
              style={{
                background: "white",
                marginTop: matches ? "45px" : "25px",
                paddingLeft: 20,
                paddingRight: 20,
                boxShadow: "-1px 3px 5px 0 rgb(0 0 0 / 16%)",
              }}
            >
              {/* <Box className={classes.radio}> */}
                {/* <Box>
                  <h1></h1>
                </Box> */}
              {/* </Box> */}
              <Grid
                container
                spacing={2}
                alignItems="center"
                style={{ marginBottom: 30,marginTop:25}}
                // style={{ marginTop: 10 }}
              >
                <Grid item xs={12} md={12} lg={3} style={{marginTop:40}}>
                  <div className={classes.root} style={{ width: "100%" }}>
                    <span style={{ color: "black" }}>Leaving From</span>
                    <Autocomplete
                      id="country-select-demo"
                      sx={{
                        // background: "#eee",
                        border: "1px solid lightgrey",
                        borderRadius: "4px",
                        padding: "7px",
                        transition: "none",
                      }}
                      clearOnBlur={true}
                      value={selectedFDSector}
                      PopperComponent={PopperMy}
                      options={
                        filterData && filterData.length > 0 ? filterData : []
                      }
                      filterOptions={(options, state) => options}
                      autoHighlight
                      getOptionLabel={(option) =>
                        `${option.sector.split("//")[0]}${option.origin} // ${
                          option.sector.split("//")[1]
                        }${option.destination} `
                      }
                      renderOption={(props, option) => (
                        <Box
                          // mr={'5px'}
                          component="li"
                          sx={{ "& > img": { mr: 2 } }}
                          {...props}
                        >
                          <img
                            loading="lazy"
                            width="20"
                            src="https://cdn-icons-png.flaticon.com/512/3125/3125713.png"
                            alt=""
                          />
                          <p style={{ fontSize: 17, marginLeft: 5 }}>
                            {`${option.sector.split("//")[0]}
																${option.origin} // ${option.sector.split("//")[1]}
																 ${option.destination}`}
                          </p>
                        </Box>
                      )}
                      onChange={(event, value) => {
                        // setFieldValue('Origin', value.airport_code);
                        dispatch(setselectedFDSector(value));
                        console.log("value", value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          onChange={handleSearchOrigin}
                          name="origin"
                        />
                      )}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} md={12} lg={3} style={{marginTop:40}}>
                  <Box display="flex" justifyContent="space-between">
                    <span style={{ color: "black" }}>Depart Date</span>
                  </Box>

                  <DesktopDateFd />
                </Grid>
                {/* Travellers Strating */}
                <Grid item xs={12} md={6} lg={3} style={{marginTop:40}}>
                  <ul
                    class="menu"
                    style={{
                      marginTop: 20,
                      borderRadius: 2,
                      // width: trip == "roundtrip" ? "110%" : "95%",
                    }}
                  >
                    <li>
                      <a
                        style={{
                          padding: 8,
                          fontSize: 16,
                          borderRadius: 4,
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          fontWeight: 600,
                          border: "1px solid lightgrey",
                        }}
                      >
                        Travellers,Classes
                      </a>

                      <ul style={{ padding: 5 }}>
                        <li>
                          <Box
                            style={{ padding: 5 }}
                            display="flex"
                            justifyContent="space-between"
                            textAlign="center"
                            alignItems="center"
                          >
                            <BodyText
                              four
                              textStyle={{
                                color: "black",
                                fontSize: 18,
                                fontWeight: 500,
                              }}
                            >
                              Adult
                            </BodyText>
                            <Box display="flex" alignItems="center">
                              <Box
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  adult === 0 ? "" : setAdult(adult - 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 18,
                                    color: "white",
                                  }}
                                >
                                  -
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                              >
                                <BodyText
                                  textStyle={{ fontSize: 17, color: "white" }}
                                >
                                  {adult}
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  adult + child + infant === 9
                                    ? adult
                                    : setAdult(adult + 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 17,
                                    color: "white",
                                  }}
                                >
                                  +
                                </BodyText>
                              </Box>
                            </Box>
                          </Box>
                        </li>
                        <li>
                          <Box
                            style={{ padding: 5 }}
                            display="flex"
                            justifyContent="space-between"
                            textAlign="center"
                            alignItems="center"
                          >
                            <BodyText
                              four
                              textStyle={{
                                color: "black",
                                fontSize: 18,
                                fontWeight: 500,
                              }}
                            >
                              Child
                            </BodyText>
                            <Box display="flex" alignItems="center">
                              <Box
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  child === 0 ? "" : setChild(child - 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 18,
                                    color: "white",
                                  }}
                                >
                                  -
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                              >
                                <BodyText
                                  textStyle={{ fontSize: 17, color: "white" }}
                                >
                                  {child}
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  adult + child + infant === 9
                                    ? child
                                    : setChild(child + 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 17,
                                    color: "white",
                                  }}
                                >
                                  +
                                </BodyText>
                              </Box>
                            </Box>
                          </Box>
                        </li>
                        <li>
                          <Box
                            style={{ padding: 5 }}
                            display="flex"
                            justifyContent="space-between"
                            textAlign="center"
                            alignItems="center"
                          >
                            <BodyText
                              four
                              textStyle={{
                                color: "black",
                                fontSize: 18,
                                fontWeight: 500,
                              }}
                            >
                              Infant
                            </BodyText>
                            <Box display="flex" alignItems="center">
                              <Box
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  infant === 0 ? "" : setInfant(infant - 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 18,
                                    color: "white",
                                  }}
                                >
                                  -
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                              >
                                <BodyText
                                  textStyle={{ fontSize: 17, color: "white" }}
                                >
                                  {infant}
                                </BodyText>
                              </Box>
                              <Box
                                ml={"15px"}
                                style={{
                                  cursor: "pointer",
                                  background: "rgb(0, 87, 94)",
                                  padding: "0px 10px",
                                  borderRadius: "5px",
                                }}
                                onClick={() =>
                                  adult + child + infant === 9
                                    ? infant
                                    : setInfant(infant + 1)
                                }
                              >
                                <BodyText
                                  textStyle={{
                                    fontSize: 17,
                                    color: "white",
                                  }}
                                >
                                  +
                                </BodyText>
                              </Box>
                            </Box>
                          </Box>
                        </li>
                        <li>
                          <Box
                            style={{ padding: 10 }}
                            display="flex"
                            justifyContent="space-between"
                          >
                            <Box className={classes.radio2}>
                              <FormControl component="fieldset">
                                <RadioGroup
                                  aria-label="gender"
                                  name="gender1"
                                  value={value}
                                  color="black"
                                  onChange={handleRadio}
                                >
                                  <FormControlLabel
                                    value="Economy"
                                    control={<Radio />}
                                    label="Economy"
                                  />
                                  <FormControlLabel
                                    value="Business"
                                    control={<Radio />}
                                    label="Business"
                                  />
                                  <FormControlLabel
                                    value="First Class"
                                    control={<Radio />}
                                    label="First Class"
                                  />
                                  <FormControlLabel
                                    value="Premium Economy"
                                    control={<Radio />}
                                    label="Premium Economy"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Box>
                          </Box>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </Grid>
                {/* Travellers Ending */}

                {/* Book Button Starting */}
                <Grid item xs={12} md={6} lg={3} style={{ marginTop: 40 }}>
                  <input
                    type="submit"
                    value="Search"
                    className="btn"
                    style={{
                      width: "100%",
                      fontSize: 20,
                      borderRadius: 4,
                      backgroundColor: "rgb(0, 87, 94)",
                      padding: 8,
                    }}
                  />
                </Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default FDSearchEngine;
